import Bootstrap from './Bootstrap';
import React from 'react';
import ReactDOM from 'react-dom';
import 'antd/dist/reset.css';

ReactDOM.render(<Bootstrap />, document.getElementById('root'));
